/**
 * url: /player/vod.html?contentid=C3601_C36000000378_01_0
 * @param url
 * @returns {string}
 */
export const getContentType = (url = '') => {
  if (url === '') {
    return ''
  }

  const regExp = /\/player\/(\w+)\.html/i
  const match = url.match(regExp)

  if (!match || !match[1]) {
    return ''
  }

  return match[1]
}
